import { ReactNode } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';

interface I18nChildrenParams {
    i18n: typeof i18n;
}

interface I18nProviderParams {
    children: ({ i18n }: I18nChildrenParams) => ReactNode;
    locale?: string;
}

export const I18nProvider = ({ children, locale: localeFromProps }: I18nProviderParams) => {
    const { locale: localeFromContext } = getContext();
    const locale = localeFromProps || localeFromContext;
    const contextualizedI18n = i18n.spawn(locale);

    if (typeof children === 'function') {
        return children({ i18n: contextualizedI18n });
    }

    return null;
};
